export default __webpack_public_path__ + "static/media/i1.45523a18.jpg";